import React from 'react'
import { Line } from 'react-chartjs-2'

const palette = [
  {
    border: 'rgba(110, 88, 255, 1)',
    background: 'rgba(110, 88, 255, 0.25)',
  },
  {
    border: 'rgba(64, 230, 255, 1)',
    background: 'rgba(64, 230, 255, 0.25)',
  },
  {
    border: 'rgba(255, 157, 79, 1)',
    background: 'rgba(255, 157, 79, 0.25)',
  },
]

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { intersect: false, mode: 'index' },
  spanGaps: false, // Не соединять линией через null значения
  plugins: {
    legend: {
      labels: {
        color: '#cbd5f5',
        usePointStyle: true,
        padding: 16,
        pointStyle: 'circle',
        boxWidth: 6,
        boxHeight: 6,
        boxPadding: 8,
      },
    },
    tooltip: {
      backgroundColor: 'rgba(15,17,28,0.92)',
      titleColor: '#f8fafc',
      bodyColor: '#e2e8f0',
      borderColor: 'rgba(148, 163, 184, 0.25)',
      borderWidth: 1,
      displayColors: false,
      padding: 14,
      cornerRadius: 14,
      filter: function(tooltipItem) {
        // Не показывать tooltip для null значений
        return tooltipItem.raw !== null
      },
      callbacks: {
        title: function(context) {
          if (context && context.length > 0) {
            const dataIndex = context[0].dataIndex;
            const label = context[0].label;
            
            // Если label содержит только время, попробуем получить полную дату из данных
            if (label && !label.includes('/') && !label.includes('-')) {
              // Это время без даты, попробуем найти исходные данные
              const chart = context[0].chart;
              if (chart && chart.data && chart.data.rawTimestamps) {
                const timestamp = chart.data.rawTimestamps[dataIndex];
                if (timestamp) {
                  return new Date(timestamp * 1000).toLocaleString('ru-KZ', {
                    timeZone: 'Asia/Almaty',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                  });
                }
              }
            }
            
            // Если уже есть дата или не можем найти timestamp, возвращаем как есть
            return label;
          }
          return '';
        },
        label: function(context) {
          // Не показывать метку для null значений
          if (context.raw === null) return null
          return `${context.dataset.label}: ${context.raw?.toFixed(2) || 0} Мбит/с`
        },
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: '#94a3b8',
        maxRotation: 45,
        autoSkip: true,
        maxTicksLimit: 12, // Максимум 12 меток на оси X
        font: {
          family: 'Inter',
          size: 10,
        },
      },
      grid: {
        color: 'rgba(148, 163, 184, 0.14)',
        drawBorder: false,
        drawTicks: false,
      },
    },
    y: {
      ticks: {
        color: '#94a3b8',
        padding: 8,
        font: {
          family: 'Inter',
          size: 11,
        },
      },
      grid: {
        color: 'rgba(148, 163, 184, 0.08)',
        drawBorder: false,
      },
      beginAtZero: true,
    },
  },
  layout: {
    padding: {
      top: 12,
      right: 12,
      bottom: 12,
      left: 12,
    },
  },
}

const HistoryGraph = ({ chartData, isLoading, emptyMessage = 'Нет данных за выбранный период', heightClass = 'h-72' }) => {
  const styledChartData = React.useMemo(() => {
    if (!chartData?.datasets) return chartData

    return {
      ...chartData,
      datasets: chartData.datasets.map((dataset, index) => {
        const paletteEntry = palette[index % palette.length]
        return {
          tension: 0.38,
          pointRadius: 0,
          borderWidth: 2,
          ...dataset,
          fill: index === 0 ? 'origin' : false,
          borderColor: paletteEntry.border,
          backgroundColor: index === 0 ? paletteEntry.background : 'transparent',
        }
      }),
    }
  }, [chartData])

  const hasChart = Boolean(styledChartData?.labels?.length)

  if (isLoading) {
    return (
      <div className={`flex ${heightClass} items-center justify-center text-sm text-muted-400`}>
        Загрузка графика...
      </div>
    )
  }

  if (!hasChart) {
    return (
      <div className={`flex ${heightClass} items-center justify-center text-sm text-muted-400`}>
        {emptyMessage}
      </div>
    )
  }

  return (
    <div className={heightClass}>
      <Line data={styledChartData} options={chartOptions} />
    </div>
  )
}

export default HistoryGraph
